<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>Category</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="m-0 p-0">

<mat-dialog-content class="px-3 py-4">

  <p>Category # {{ category.id }}</p>

  <p>Category: {{ category.category }}</p>

  <p>Created on {{ (category.date_created * 1000) | timezoneConvertMedium }} {{ category.created_by_user ? ('by ' + category.created_by_user.contact_person) : '' }} </p>

  <p *ngIf="category.date_modified">Last Updated on {{ (category.date_modified * 1000) | timezoneConvertMedium }} {{ category.updated_by_user ? ('by ' + category.updated_by_user.contact_person) : '' }} </p>

  <ng-container *ngIf="category.forms && category.forms.length > 0">
    <h5>Associated Forms</h5>
    <mat-list>
      <mat-list-item *ngFor="let dynamic_form of category.forms"> #{{ dynamic_form.id }} - {{ dynamic_form.title }} ({{ dynamic_form.is_active ? 'Active' : 'Inactive' }}) </mat-list-item>
     </mat-list>
  </ng-container>

</mat-dialog-content>
